// General
import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose, Query } from 'react-apollo';
import gql from 'graphql-tag';

// Styles
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Profile.css';

// Component
import ViewProfile from '../../components/ViewProfile';
import Loader from '../../components/Loader';
import NotFound from '../notFound/NotFound';

// GraphQL
import ProfileQuery from './Profile.graphql';
import UserReviewsQuery from './UserReviews.graphql';
import { getp } from '../../helpers/getProp';

class Profile extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    profileId: PropTypes.number,
    isUser: PropTypes.bool,
  };

  static defaultProps = {
    isUser: false,
  };

  constructor(props) {
    super(props);
    this.loadMore = this.loadMore.bind(this);
  }

  loadMore() {
    const {
      profileData: { showUserProfile, fetchMore },
      profileId,
    } = this.props;
    fetchMore({
      query: UserReviewsQuery,
      variables: {
        ownerType: 'others',
        offset: showUserProfile.reviews.length,
        profileId,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return previousResult;
        }

        return {
          showUserProfile: {
            ...previousResult.showUserProfile,
            reviews: [
              ...previousResult.showUserProfile.reviews,
              ...fetchMoreResult.userReviews,
            ],
          },
        };
      },
    });
  }

  render() {
    const { title, profileId, isUser } = this.props;

    return (
      <div className="f f-1">
        {profileId && (
          <Query query={ProfileQuery} variables={{ profileId }}>
            {({ data, loading }) => {
              if (loading) {
                return <Loader />;
              } else if (!data) {
                return <NotFound />;
              } else {
                return (
                  <ViewProfile
                    data={getp(data, 'getProfile.0', {})}
                    isUser={isUser}
                    profileId={profileId}
                  />
                );
              }
            }}
          </Query>
        )}
      </div>
    );
  }
}

export default compose(withStyles(s))(Profile);



// WEBPACK FOOTER //
// ./src/routes/profile/Profile.js